export interface OverviewDetailReponse {
  data: OverviewDetail;
}

export interface OverviewDetail {
  name: string;
  display_name: string;
  logo_uri: string;
  description: string;
  transactions_count: number;
  last_date_modified: string;
}

export enum OverviewLoadingStatus {
  FIRST_LOAD = 1,
  SECOND_LOAD = 2,
  NORMAL_LOAD = 3,
  LOADING_ERROR = 4,
}

export interface CustomNameMap {
  customNameForApi: string;
  customNameForMapping: string;
}